import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  decimalValue,
  getMerchantCurrencySymbol,
  searchTableHandler,
  searchTextVal,
} from "../../../helpers";
import { changeMenuValue, getMenuIngredients } from "../../../Redux/actions";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Ingredients = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { ingredient_details } = useSelector((state) => state.menuReducer);
  const { user_details } = useSelector((state) => state.authReducer);
  const [listStatus, setListStatus] = useState(1);
  const pagesize = 10;

  const getIngredientsHandler = (page = 1, status = 1) => {
    dispatch(getMenuIngredients({ page, status, pagesize }));
  };

  useEffect(() => {
    getIngredientsHandler();

    return () => {
      dispatch(changeMenuValue("ingredient_details", null));
    };
  }, []);

  useEffect(() => {
    getIngredientsHandler(1, listStatus);
  }, [listStatus]);

  const getPaginationContainer = () => {
    let res = null;
    if (
      checkNull(ingredient_details?.last_page, false) &&
      ingredient_details?.last_page > 1
    ) {
      const pagesArr = Array.from(
        { length: ingredient_details?.last_page },
        (_, i) => i + 1
      );
      res = (
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            {pagesArr.map((pageNo) => {
              return (
                <li
                  class={`page-item${
                    pageNo == ingredient_details?.current_page ? " active" : ""
                  }`}
                  onClick={() => {
                    if (!(pageNo == ingredient_details?.current_page)) {
                      getIngredientsHandler(pageNo, listStatus);
                    }
                  }}
                >
                  <a class="page-link">{pageNo}</a>
                </li>
              );
            })}
          </ul>
        </nav>
      );
    }
    return res;
  };

  const getIngredientActionBtn = (intreg) => {
    let res = null;
    if (
      (intreg?.parent_id > 0 &&
        intreg?.merchant_id == user_details?.user?.merchant_id) ||
      (checkNull(intreg?.parent_id, false) && intreg?.is_editable == 2)
    ) {
    } else {
      res = (
        <a
          class="circle_icon"
          onClick={() => history.push(`/menu/ingredients/edit/${intreg?.id}`)}
        >
          <i class="iconSprites edit-icon">
            <div class="tooltip-sm"> Edit </div>
          </i>
        </a>
      );
    }
    return res;
  };

  const getPurcahseMeasureUnitDiv = (payee) => {
    return `${decimalValue(
      payee?.purchase_price,
      4,
      getMerchantCurrencySymbol(user_details)
    )} per ${payee?.measurement_unit?.symbol ?? ""}`;
  };

  const getIngredientTableCon = () => {
    return (
      <div className="table-responsive">
        <table
          width="100%"
          cellspacing="0"
          cellpadding="0"
          class="checklist-table table850 remove-space inventory_table"
        >
          <thead>
            <tr>
              <th> ID </th>
              {user_details?.user?.merchant?.parent_merchant_id > 0 && (
                <th> Parent ID </th>
              )}
              <th>
                <span>Ingredient Name</span>
              </th>
              <th>Category</th>
              <th>Supplier Name</th>
              <th>Purchase Measurement Units</th>
              <th className="action-td"> Action </th>
            </tr>
          </thead>
          <tbody>
            {checkArray(ingredient_details?.data) &&
              ingredient_details?.data
                .filter((item) => ingredientSearchHandler(item))
                .map((ingredient) => {
                  return (
                    <tr>
                      <td>{ingredient?.id}</td>
                      {user_details?.user?.merchant?.parent_merchant_id > 0 && (
                        <td>{ingredient?.parent_id ?? "NA"}</td>
                      )}
                      <td>
                        <span>{checkNull(ingredient?.ingredient_name)}</span>
                      </td>
                      <td>{checkNull(ingredient?.category?.name)}</td>
                      <td>
                        {" "}
                        {checkArray(ingredient?.ingredient_conv_multiplier) &&
                          ingredient?.ingredient_conv_multiplier.map(
                            (payee) => {
                              return (
                                <>
                                  <span>{checkNull(payee?.payee_name)}</span>
                                  <br />
                                </>
                              );
                            }
                          )}
                        <br />
                      </td>
                      <td>
                        {checkArray(ingredient?.ingredient_conv_multiplier) &&
                          ingredient?.ingredient_conv_multiplier.map(
                            (payee) => {
                              return (
                                <>
                                  <span>
                                    {getPurcahseMeasureUnitDiv(payee)}
                                  </span>
                                  <br />
                                </>
                              );
                            }
                          )}
                      </td>
                      <td className="action-td">
                        {getIngredientActionBtn(ingredient)}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
        {getPaginationContainer()}
      </div>
    );
  };

  // search
  const [ingredientSearch, setIngredientSearch] = useState("");
  const ingredientSearchHandler = (ingredient) => {
    let resp = true;
    if (checkNull(ingredientSearch, false)) {
      let searchText = ingredientSearch.toLowerCase();
      resp = false;
      if (
        searchTableHandler(
          [
            ingredient?.id,
            ingredient?.ingredient_name,
            ingredient?.category?.name,
          ],
          searchText
        )
      ) {
        resp = true;
      } else if (
        checkArray(ingredient?.ingredient_conv_multiplier) &&
        ingredient?.ingredient_conv_multiplier.findIndex((p) =>
          searchTextVal(p?.payee_name, searchText)
        ) > -1
      ) {
        resp = true;
      } else if (
        checkArray(ingredient?.ingredient_conv_multiplier) &&
        ingredient?.ingredient_conv_multiplier.findIndex((p) =>
          searchTextVal(getPurcahseMeasureUnitDiv(p), searchText)
        ) > -1
      ) {
        resp = true;
      }
    }
    return resp;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="shadowclass">
                  <div className="top-header-sec d-flex justify-content-between mb-0">
                    <h4 className="event-alert mb-3 col-md-4">
                      Ingredients List
                      <div className="clear"></div>
                    </h4>
                    <ul
                      class="nav summary_filter col-md-4"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <a
                          class={`nav-link${listStatus == 1 ? " active" : ""}`}
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected={`${
                            listStatus == 1 ? "true" : "false"
                          }`}
                          onClick={() => setListStatus(1)}
                        >
                          Active
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          class={`nav-link${listStatus == 1 ? "" : " active"}`}
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected={`${
                            listStatus == 1 ? "false" : "true"
                          }`}
                          onClick={() => setListStatus(2)}
                        >
                          Inactive
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="row justify-content-between align-items-center w-100 mx-0">
                    <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                      <div className="search-box mt-0">
                        <form type="GET">
                          <input
                            type="text"
                            placeholder="Search"
                            name="keyword1"
                            value={ingredientSearch}
                            autocomplete="off"
                            onChange={(e) =>
                              setIngredientSearch(e?.target?.value ?? "")
                            }
                          />
                          <input type="button" />
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-7 col-12 align-right px-0">
                      <div class="field text-right">
                        <button
                          class="btn green-btn-revert add-plus addSp mx-0"
                          id="addCount"
                          type="button"
                          onClick={() =>
                            history.push("/menu/ingredients/new-ingredient")
                          }
                        >
                          <i class="i-icon"> </i> Add Ingredient
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row mx-0 my-4">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        {getIngredientTableCon()}
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-profile"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                      >
                        {getIngredientTableCon()}
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-contact"
                        role="tabpanel"
                        aria-labelledby="pills-contact-tab"
                      >
                        ...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Ingredients;
